var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tit && _vm.descr)?_c('HeadingBox',{attrs:{"title":_vm.tit,"description":_vm.descr,"role":"alert","aria-atomic":"true"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }